function init() {
  document.addEventListener('facetwp-loaded', function () {
    // Reset auto_refresh to true on each load
    FWP.auto_refresh = true;

    // Make FacetWP checkboxes accessible and disable auto-refresh
    document
      .querySelectorAll('.facetwp-type-checkboxes .facetwp-checkbox')
      .forEach(function (checkboxDiv) {
        // Make div focusable and add ARIA attributes
        checkboxDiv.setAttribute('tabindex', '0');
        checkboxDiv.setAttribute('role', 'checkbox');

        // Get the current checked state
        const isChecked = checkboxDiv.classList.contains('checked');
        checkboxDiv.setAttribute('aria-checked', isChecked);

        // Handle click events
        checkboxDiv.addEventListener('click', function () {
          FWP.auto_refresh = false;
        });

        // Handle keyboard events
        checkboxDiv.addEventListener('keydown', function (e) {
          // Handle Enter and Space keys
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            // Toggle the checkbox
            checkboxDiv.click();

            // Update aria-checked attribute
            const newCheckedState = checkboxDiv.classList.contains('checked');
            checkboxDiv.setAttribute('aria-checked', newCheckedState);
          }
        });
      });

    // Replace icon with search button
    document.querySelectorAll('.facetwp-type-search').forEach(function (facet) {
      const icon = facet.querySelector('i.facetwp-icon');
      if (icon) {
        icon.remove();
        const button = document.createElement('button');
        button.className = 'facetwp-search-button';
        button.type = 'button';
        button.textContent = 'Search';
        facet.appendChild(button);

        button.addEventListener('click', function () {
          FWP.refresh();
        });
      }
    });

    // Apply filters button triggers refresh and reenables auto refresh
    document.getElementById('applyFilters')?.addEventListener('click', function (e) {
      e.preventDefault();
      FWP.auto_refresh = true;
      FWP.refresh();

      // jQuery: Hide the filter section
      jQuery('#resourceFilters').slideUp(300);
    });

    // --- jQuery toggle for Filter By ---
    jQuery(function ($) {
      const $filterBy = $('#filterBy');
      const $resourceFilters = $('#resourceFilters');
      const $applyFilters = $('#applyFilters');
      const $resetButtons = $('.facetwp-reset');

      // Hide initially and set state
      $resourceFilters.hide().attr('data-open', 'false');

      $filterBy.off('click').on('click', function (e) {
        e.preventDefault();

        const isOpen = $resourceFilters.attr('data-open') === 'true';

        if (isOpen) {
          $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
        } else {
          $resourceFilters.stop(true, true).slideDown(300).attr('data-open', 'true');
        }
      });

      $applyFilters.off('click').on('click', function (e) {
        $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
      });

      $resetButtons.off('click').on('click', function () {
        $resourceFilters.stop(true, true).slideUp(300).attr('data-open', 'false');
      });
    });

    // --- end jQuery toggle ---

    // Clear previous filter terms
    const filterContainer = document.getElementById('resourceFilterTerms');
    const filterWrapper = filterContainer?.closest('.facet-clear-wrapper');

    if (filterContainer) {
      filterContainer.innerHTML = ''; // Reset contents
    }

    // Track whether any filters are applied
    let filtersFound = false;

    // List of checkbox facets to check
    let checkboxFacets = [];

    if (document.body.classList.contains('post-type-archive-resource')) {
      // resource library
      checkboxFacets = ['resource_type', 'resource_topic', 'resource_product'];
    } else if (document.body.classList.contains('blog')) {
      // blog archive
      checkboxFacets = ['blog_topics', 'blog_author', 'resource_product', 'blog_tag'];

      // change search placeholder text for blog archive
      const searchInput = document.querySelector('.facetwp-search');
      if (searchInput) {
        searchInput.placeholder = 'Search for posts..';
      }
    }

    // ---------- URL helpers for zero-results fallback ----------
    function facetToParamKey(facet) {
      // Matches your URL pattern: ?_resource_topic=...&_resource_type=...
      return `_${facet}`;
    }

    function norm(x) {
      try {
        return decodeURIComponent(String(x)).trim().toLowerCase();
      } catch {
        return String(x).trim().toLowerCase();
      }
    }

    function removeFacetValueFromUrl(facet, value) {
      const key = facetToParamKey(facet);
      const url = new URL(window.location.href);
      const params = url.searchParams;

      if (!params.has(key)) return false;

      const current = params.get(key);
      if (!current) return false;

      // Comma-separated values
      const parts = current.split(',').filter((s) => s !== '');
      const filtered = parts.filter((v) => norm(v) !== norm(value));

      if (filtered.length === parts.length) {
        return false; // no change
      }

      if (filtered.length > 0) {
        params.set(key, filtered.join(','));
      } else {
        params.delete(key);
      }

      // Also clear paging so you don’t land on an empty page
      params.delete('fwp_paged');
      params.delete('paged');

      url.search = params.toString();
      window.location.href = url.toString(); // navigate with only this one value removed
      return true;
    }
    // -----------------------------------------------------------

    checkboxFacets.forEach((facet) => {
      const values = FWP.facets[facet];

      if (values && values.length > 0) {
        filtersFound = true;

        values.forEach((value) => {
          let labelText;

          if (facet === 'blog_author') {
            const checkboxDiv = document.querySelector(
              `.facetwp-facet-${facet} .facetwp-checkbox[data-value="${value}"]`
            );
            const displaySpan = checkboxDiv?.querySelector('.facetwp-display-value');

            if (displaySpan) {
              labelText = displaySpan.textContent;
            } else {
              labelText = window.facetData?.authorNames?.[value] || `Author ${value}`;
            }
          } else {
            labelText = value
              .split('-')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          }

          const span = document.createElement('span');
          span.className = 'facet-filter-term';
          span.textContent = `${labelText}`; // Display label
          span.setAttribute('role', 'button');
          span.setAttribute('tabindex', '0');
          span.setAttribute('aria-label', `Remove filter: ${labelText}`);
          // Keep the raw values for URL surgery
          span.dataset.facet = facet;
          span.dataset.value = value;

          filterContainer?.appendChild(span);

          // Make entire span clickable to remove the filter
          span.addEventListener('click', function () {
            const { facet, value } = span.dataset;

            // 1) Try the normal path (visible checkbox is present & checked)
            const targetCheckbox = document.querySelector(
              `.facetwp-facet-${facet} .facetwp-checkbox[data-value="${value}"]`
            );

            if (targetCheckbox && targetCheckbox.classList.contains('checked')) {
              targetCheckbox.click(); // uncheck just this one
              FWP.refresh();
              return;
            }

            // 2) Zero-results fallback: remove just this value from the URL param (e.g., _resource_topic)
            const didChange = removeFacetValueFromUrl(facet, value);

            // If no change, do nothing—don’t risk nuking other selections
            if (!didChange) {
              // Optional: console.warn('Param not found or value not present in URL', facet, value);
            }
          });

          span.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault(); // stop page from scrolling on Space
              span.click();
            }
          });
        });
      }
    });

    // Toggle the wrapper's display
    if (filterWrapper) {
      filterWrapper.style.display = filtersFound ? 'flex' : 'none';
    }

    // loader things to prevent showing flashing of unstyled content while facet is loading content
    jQuery(document).on('facetwp-refresh', function () {
      // Show loader on the template container
      jQuery('.archive-listing').addClass('facetwp-loading');
    });

    jQuery(document).on('facetwp-loaded', function () {
      // Hide loader after loading is complete
      jQuery('.archive-listing').removeClass('facetwp-loading');
    });

    // Add event listener specifically to the load more button
    const loadMoreButton = document.querySelector('.facetwp-load-more');
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        // Clear any unsearched text from search inputs
        document.querySelectorAll('.facetwp-search').forEach(function (searchInput) {
          if (!searchInput.dataset.searchCommitted) {
            searchInput.value = '';
          }
        });
      });
    }
  });
}

export { init as default };
